let _callback = null;

export function registerSave(fn) {
    _callback = fn;
}

export function unregisterSave() {
    _callback = null;
}

export async function triggerSave() {
    if (_callback) {
        await _callback();
    }
}
